import { useState } from 'react';
import B29PriceListPanel from './B29PriceListPanel';
import SupplierPriceListPanel from './SupplierPriceListPanel';

const ORANGE = '#ee7203';

/**
 * The View Price Lists slide-out on the Create Quote window: a tab at the top switches between the B29 price lists and the
 * Supplier price lists (the ones switched ON in Settings > Pricing). Both behave the same — pick a supplier, browse its
 * products by category, "+" adds a product to the quote. Both stay mounted so switching tabs keeps your place in each.
 */
const QuotePriceListsPanel = ({ onAddB29Product = null, onAddSupplierProduct = null }) => {
  const [tab, setTab] = useState('b29');
  const tabs = [{ id: 'b29', label: 'B29' }, { id: 'supplier', label: 'Supplier' }];
  return (
    <div className="h-full flex flex-col" data-testid="quote-pricelists-wrapper">
      <div className="flex items-center gap-2 px-4 pt-3 pb-2 border-b border-orange-100 flex-shrink-0" data-testid="quote-pricelists-tabs">
        {tabs.map((t) => {
          const active = tab === t.id;
          return (
            <button
              key={t.id}
              type="button"
              onClick={() => setTab(t.id)}
              className={`rounded-full px-4 py-1.5 text-xs font-bold border-2 transition-colors ${active ? 'text-white border-orange-500' : 'text-orange-700 bg-orange-50 border-orange-200 hover:bg-orange-100'}`}
              style={active ? { backgroundColor: ORANGE } : undefined}
              data-testid={`quote-pricelists-tab-${t.id}`}
            >
              {t.label}
            </button>
          );
        })}
      </div>
      <div className="flex-1 min-h-0">
        <div className={tab === 'b29' ? 'h-full' : 'hidden'}><B29PriceListPanel onAddProduct={onAddB29Product} /></div>
        <div className={tab === 'supplier' ? 'h-full' : 'hidden'}><SupplierPriceListPanel onAddProduct={onAddSupplierProduct} /></div>
      </div>
    </div>
  );
};

export default QuotePriceListsPanel;
